export type AsaasHandoff = 'browser' | 'desktop';

export interface AsaasReturnQuery {
  returnId: string;
  handoff: AsaasHandoff;
}

const RETURN_ID_MAX_LENGTH = 128;

export function isValidAsaasReturnId(value: string): boolean {
  return value.length > 0 && value.length <= RETURN_ID_MAX_LENGTH && value !== '__proto__';
}

export function buildAsaasPaymentResultUrl(
  returnId: string,
  handoff: AsaasHandoff,
  location: Pick<Location, 'origin' | 'pathname' | 'protocol'> = window.location,
): string | undefined {
  if (location.protocol !== 'https:' || !location.origin || location.origin === 'null') {
    return undefined;
  }
  const query = new URLSearchParams({ paymentResult: 'asaas', returnId, handoff });
  return `${location.origin}${location.pathname}#/payment/asaas/return?${query.toString()}`;
}

export function parseAsaasReturnQuery(search: string): AsaasReturnQuery | undefined {
  const params = new URLSearchParams(search);
  const returnId = params.get('returnId');
  const handoff = params.get('handoff');
  if (
    params.get('paymentResult') !== 'asaas' ||
    !returnId ||
    !isValidAsaasReturnId(returnId) ||
    (handoff !== 'browser' && handoff !== 'desktop')
  ) {
    return undefined;
  }
  return { returnId, handoff };
}

export function peekAsaasMarketReturn(search: string): { returnId?: string } | undefined {
  const params = new URLSearchParams(search);
  if (params.get('paymentResult') !== 'asaas') return undefined;
  const returnId = params.get('returnId');
  return { returnId: returnId && isValidAsaasReturnId(returnId) ? returnId : undefined };
}

export function loginPathWithAsaasReturn(location: Pick<Location, 'pathname' | 'search'>): string {
  if (new URLSearchParams(location.search).get('paymentResult') !== 'asaas') return '/login';
  const nextpage = `${location.pathname}${location.search}`;
  return `/login?nextpage=${encodeURIComponent(nextpage)}`;
}

export function asaasBrowserReturnChannelName(returnId: string): string {
  return `@fett/asaas-payment-return:${returnId}`;
}

export function asaasDesktopDeepLink(returnId: string): string | undefined {
  if (!isValidAsaasReturnId(returnId)) return undefined;
  return `chatplusai://payment/asaas-return?returnId=${encodeURIComponent(returnId)}`;
}

export function asaasMarketReturnPath(returnId?: string): string {
  const query = new URLSearchParams({ paymentResult: 'asaas' });
  if (returnId) query.set('returnId', returnId);
  return `/management/service/market?${query.toString()}`;
}
